<template>
    <ul class="list-inline">
        <li class="list-inline-item" v-if="sitesettings.facebookurl">
            <a :href="sitesettings.facebookurl" target="_blank">
                <span class="ico ico-svg svg-facebook"></span>
            </a>
        </li>
        <li class="list-inline-item" v-if="sitesettings.twitterurl">
            <a :href="sitesettings.twitterurl" target="_blank">
                <span class="ico ico-svg svg-twitter"></span>
            </a>
        </li>
        <li class="list-inline-item" v-if="sitesettings.instagramurl">
            <a :href="sitesettings.instagramurl" target="_blank">
                <span class="ico ico-svg svg-instagram"></span>
            </a>
        </li>
        <li class="list-inline-item" v-if="sitesettings.youtubeurl">
            <a :href="sitesettings.youtubeurl" target="_blank">
                <span class="ico ico-svg svg-youtube"></span>
            </a>
        </li>
        <li class="list-inline-item" v-if="sitesettings.soundcloudurl">
            <a :href="sitesettings.soundcloudurl" target="_blank">
                <span class="ico ico-svg svg-soundcloud"></span>
            </a>
        </li>
        <li class="list-inline-item" v-if="sitesettings.telegramurl">
            <a :href="sitesettings.telegramurl" target="_blank">
                <span class="ico ico-svg svg-telegram"></span>
            </a>
        </li>
        <li class="list-inline-item" v-if="sitesettings.whatsappurl">
            <a :href="'tel:'+sitesettings.whatsappurl" target="_blank">
                <span class="ico ico-svg svg-whatsapp"></span>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        sitesettings: Object
    }
}
</script>
